import { DataListConfig } from '@tripointe/tripointe-cms/types';
import {
  FindUsersDocument,
  FetchUsersCountDocument,
  GetLotUpdatesDocument,
  GetDivisionsDocument,
  GetCommunitiesDocument,
  GetContactsDocument,
  FindCommunityTeamMembersDocument,
  GetDefaultPhasesDocument,
  GetPhasesDocument,
  FetchCommunitiesCountDocument,
  FetchDivisionsCountDocument,
  GetPlansWithPaginationDocument,
  GetHomesDocument,
  FetchHomesCountDocument,
  GetEventsWithPaginationDocument,
  GetPlansCountDocument,
  GetDocumentsCountDocument,
  FetchEventsCountDocument,
  GetDocumentsWithPaginationDocument,
  GetBuyersWithPaginationDocument,
  GetPhaseTipsDocument,
  FindLotAppointmentsWithPaginationDocument,
  FetchElevationsCountDocument,
  FetchContactsCountDocument,
  FindConversationsPaginatedDocument,
  FetchDefaultPhasesCountDocument,
  FetchPhasesCountDocument,
  GetPhaseTipsWithPaginationDocument,
  GetLotGalleryImagesDocument,
  FetchPhaseTipsCountDocument,
  GetHomeDocumentsWithPaginationDocument,
  GetHomeDocumentsCountDocument,
  FetchContactTypesCountDocument,
  FindContactTypesDocument,
  FindElevationsPaginatedDocument,
  GetDefaultPhasesWithPaginationDocument,
  GetPhasesWithPaginationDocument,
  FindCompaniesPaginatedDocument,
  FetchCompaniesCountDocument,
  FindCommunityTeamMembersForLotDocument,
  GetDefaultPhaseTipsPaginatedDocument,
  FetchDefaultPhaseTipsCountDocument,
  GetConversationsCountDocument,
  GetLotPhotos149ListDocument
} from '@tripointe/tripointe-cms/data-access';

export const USERS_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: FindUsersDocument,
  dataAccessKey: 'findUsers',
  statsDocument: FetchUsersCountDocument,
  statsAccessKey: 'fetchUsersCount'
};

export const DIVISIONS_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetDivisionsDocument,
  dataAccessKey: 'getDivisions',
  statsDocument: FetchDivisionsCountDocument,
  statsAccessKey: 'fetchDivisionsCount'
};

export const COMMUNITIES_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetCommunitiesDocument,
  dataAccessKey: 'getCommunities',
  statsDocument: FetchCommunitiesCountDocument,
  statsAccessKey: 'fetchCommunitiesCount'
};

export const CONTACTS_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetContactsDocument,
  dataAccessKey: 'getContacts',
  statsDocument: FetchContactsCountDocument,
  statsAccessKey: 'fetchContactsCount'
};

export const COMMUNITY_CONTACTS_CONFIG: DataListConfig = {
  dataDocument: FindCommunityTeamMembersDocument,
  dataAccessKey: 'findCommunityTeamMembers'
};

export const HOME_CONTACTS_CONFIG: DataListConfig = {
  dataDocument: FindCommunityTeamMembersDocument,
  dataAccessKey: 'findCommunityTeamMembers'
};

export const CONTACT_TYPES_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: FindContactTypesDocument,
  dataAccessKey: 'findContactTypes',
  statsDocument: FetchContactTypesCountDocument,
  statsAccessKey: 'fetchContactTypesCount'
};

export const CONTACT_VENDORS_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: FindCompaniesPaginatedDocument,
  dataAccessKey: 'findCompaniesPaginated',
  statsDocument: FetchCompaniesCountDocument,
  statsAccessKey: 'fetchCompaniesCount'
};

export const HOME_SCHEDULE_CONFIG: DataListConfig = {
  dataDocument: FindLotAppointmentsWithPaginationDocument,
  dataAccessKey: 'findLotAppointmentsWithPagination'
};
export const DEFAULT_PHASES_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetDefaultPhasesWithPaginationDocument,
  dataAccessKey: 'getDefaultPhasesWithPagination',
  statsDocument: FetchDefaultPhasesCountDocument,
  statsAccessKey: 'fetchDefaultPhasesCount'
};
export const PHASES_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetPhasesWithPaginationDocument,
  dataAccessKey: 'getPhasesWithPagination',
  statsDocument: FetchPhasesCountDocument,
  statsAccessKey: 'fetchPhasesCount'
};
export const PHASE_TIPS_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetPhaseTipsWithPaginationDocument,
  dataAccessKey: 'getPhaseTipsWithPagination',
  statsDocument: FetchPhaseTipsCountDocument,
  statsAccessKey: 'fetchPhaseTipsCount'
};

export const DEFAULT_PHASE_TIPS_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetDefaultPhaseTipsPaginatedDocument,
  dataAccessKey: 'getDefaultPhaseTipsPaginated',
  statsDocument: FetchDefaultPhaseTipsCountDocument,
  statsAccessKey: 'fetchDefaultPhaseTipsCount'
};

export const PLANS_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetPlansWithPaginationDocument,
  dataAccessKey: 'getPlansWithPagination',
  statsDocument: GetPlansCountDocument,
  statsAccessKey: 'getPlansCount'
};

export const EVENTS_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetEventsWithPaginationDocument,
  dataAccessKey: 'getEventsWithPagination',
  statsDocument: FetchEventsCountDocument,
  statsAccessKey: 'fetchEventsCount'
};

export const DOCUMENTS_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetDocumentsWithPaginationDocument,
  dataAccessKey: 'getDocumentsWithPagination',
  statsDocument: GetDocumentsCountDocument,
  statsAccessKey: 'getDocumentsCount'
};

export const HOMES_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetHomesDocument,
  dataAccessKey: 'getHomes',
  statsDocument: FetchHomesCountDocument,
  statsAccessKey: 'fetchHomesCount'
};

export const HOME_LOGINS_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetBuyersWithPaginationDocument,
  dataAccessKey: 'getBuyersWithPagination'
};

export const HOME_GALLERY_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetLotGalleryImagesDocument,
  dataAccessKey: 'getLotGalleryImages'
};

export const HOME_PHOTOS149_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetLotPhotos149ListDocument,
  dataAccessKey: 'getLotPhotos149List'
};

export const HOME_UPDATES_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetLotUpdatesDocument,
  dataAccessKey: 'getLotUpdates'
};

export const PLAN_ELEVATIONS_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: FindElevationsPaginatedDocument,
  dataAccessKey: 'findElevationsPaginated',
  statsDocument: FetchElevationsCountDocument,
  statsAccessKey: 'fetchElevationsCount'
};

export const HOME_DOCUMENTS_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: GetHomeDocumentsWithPaginationDocument,
  dataAccessKey: 'getHomeDocumentsWithPagination',
  statsDocument: GetHomeDocumentsCountDocument,
  statsAccessKey: 'getHomeDocumentsCount'
};

export const CHATS_DATA_LIST_CONFIG: DataListConfig = {
  dataDocument: FindConversationsPaginatedDocument,
  dataAccessKey: 'findConversationsPaginated',
  statsDocument: GetConversationsCountDocument,
  statsAccessKey: 'getConversationsCount'
};
